import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=00ff408e&scoped=true&"
import script from "./ProductHeader.vue?vue&type=script&lang=ts&"
export * from "./ProductHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=00ff408e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff408e",
  null
  
)

export default component.exports